import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img
    src="/logo-emblem.png"
    alt="Castles Creation"
    className={`${className} rounded-xl object-cover ring-1 ring-[#D4AF37]/30 transition-transform duration-300 group-hover:scale-105`}
  />
);

export const Logo = ({ small }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
    <LogoMark />
    {!small && (
      <span className="font-display text-white text-lg tracking-tight leading-none">
        Castles <span className="text-[#D4AF37]">Creation</span>
      </span>
    )}
  </Link>
);

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`rounded-full bg-[#D4AF37] text-[#0A1633] font-semibold px-7 py-3.5 text-sm sm:text-base transition-all duration-300 hover:bg-[#e5c558] hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(212,175,55,0.25)] active:translate-y-0 disabled:opacity-50 disabled:pointer-events-none ${className}`}
  >
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...props }) => (
  <button
    {...props}
    className={`rounded-full border border-white/15 text-slate-200 px-6 py-3 text-sm transition-all duration-300 hover:border-[#D4AF37]/60 hover:text-[#D4AF37] hover:-translate-y-0.5 ${className}`}
  >
    {children}
  </button>
);

export const Input = ({ label, hint, ...props }) => (
  <label className="block text-left">
    {label && <span className="block text-xs tracking-[0.15em] uppercase text-slate-400 mb-2">{label}</span>}
    <input
      {...props}
      className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-slate-500 outline-none transition-colors duration-300 focus:border-[#D4AF37]/70 focus:bg-white/[0.07]"
    />
    {hint && <span className="block text-xs text-slate-500 mt-2 leading-relaxed">{hint}</span>}
  </label>
);

export const Select = ({ label, children, ...props }) => (
  <label className="block text-left">
    {label && <span className="block text-xs tracking-[0.15em] uppercase text-slate-400 mb-2">{label}</span>}
    <select
      {...props}
      className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 text-white outline-none transition-colors duration-300 focus:border-[#D4AF37]/70 [&>option]:bg-[#0A1633]"
    >
      {children}
    </select>
  </label>
);
